import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  title: css`
    text-align: center;
  `,
  icon: css`
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 16px;
    svg {
      color: ${colors.prussian};
    }
  `,
  dialog: css`
    z-index: 9999 !important;

    & .MuiPaper-root {
      margin: 0px 16px;
    }
    & .MuiDialog-paper {
      border-radius: 8px;
      padding: 24px 20px;
    }
    & .MuiDialogContent-root {
      padding: 16px 0px 24px;
    }
    & .MuiDialogActions-root {
      width: 100%;
      justify-content: space-between;
      padding: 0px;
      & button {
        width: 100%;
        white-space: nowrap;
      }
      & > :not(:first-of-type) {
        margin-left: 16px;
      }
    }
  `,
  container: css`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    background-color: ${colors.white};
    padding: 24px 0px 23px 0px;
    border-bottom: 1px solid ${colors.silver};
    margin-bottom: 24px;
  `,
  backButtonPosition: css`
    position: absolute;
    left: 8px;
  `,
  closeButtonPosition: css`
    position: absolute;
    left: 21px;
    top: 18px;
  `,
};

export default styles;
